export const BASE = '/';
export const MAIN_PAGE = '/main';
export const SCHEDULE_PAGE = '/schedule';
export const ERROR_PAGE = '/error';
